import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Box, Button, TableBody} from "@mui/material";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useMyAcceptDiscounts } from "../../hooks/useMyAcceptDiscounts";

export default function DiscountsCategoriesByAdmin() {
  const { t } = useTranslation();
  function convertDate(dateString) {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // yyyy-mm-dd
}
  const columns = [
    { id: "image Discount", label: t("Image Discount"), minWidth: 150 },
    { id: "title", label: t("title"), minWidth: 150 },
    { id: "description", label: t("description"), minWidth: 150 },
    { id: "discount Type", label: t("Discount Type"), minWidth: 150 },
    { id: "discount StartDate", label: t("discount StartDate"), minWidth: 150 },
    { id: "discount endDate", label: t("discount EndDate"), minWidth: 150 },
    { id: "Discount Percentage", label: t("Discount Percentage"), minWidth: 150 },
    { id: "amountBeforeDiscount", label: t("Amount Before Discount"), minWidth: 150 },
    { id: "amountAfterDiscount", label: t("Amount After Discount"), minWidth: 150 },
    { id: "update", label: t("update"), minWidth: 150 },
    { id: "delete", label: t("delete"), minWidth: 150 },
  ];

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { data, isLoading } = useMyAcceptDiscounts();
  useEffect(() => {
    if (data?.data) {
      setCategoires(data.data);
    }
  }, [data]);

  const [categories, setCategoires] = useState([]);

  const { closeSnackbar, enqueueSnackbar } = useSnackbar();
  const lang = Cookies.get("i18next") || "en";

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

    const navigate = useNavigate();
  
  const handelEdit= (id)=>{
    navigate(`/admin/edit-discount/${id}`)
  }

  // Added by Abdelwahab
  const handleDelete = async (id) => {
    closeSnackbar();
    const isConfirmed = window.confirm(t("confirm_dangerous_action"));
    if (!isConfirmed) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_KEY}api/v1/teacher/discounts/delete-discount/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json"
          },
        }
      );
      
      if (res.status!==200) {
        enqueueSnackbar(t("The deletion process failed."), { variant: "error",autoHideDuration: 8000  });
      } else {
        enqueueSnackbar(t("discount deleted successfully"), {variant: "success", autoHideDuration: 8000  });
        filterTeachers(id)
      }
    } catch (err) {
      enqueueSnackbar(t("The deletion process failed."), { variant: "error",autoHideDuration: 8000  });
    }
  };

  
  function filterTeachers(id) {
    const filteredTeachers = categories.filter(
      (teacher) => teacher.id.toString() !== id.toString()
    );
    setCategoires(filteredTeachers);
  }
  
  return (
    <Box>
      {!isLoading ? (
        <Paper sx={{ width: "100%", padding: "20px" }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            {/* <TextField
              sx={{ m: 1, width: "90%" }}
              label={t("search")}
              variant="outlined"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            /> */}
            <Table stickyHeader aria-label="sticky table">
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={"center"}
                    style={{ top: 57, minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
              <TableBody>
                {categories
                  ?.map((row) => {
                    return (
                      <TableRow hover role="checkbox" key={row.id + "demj"}>
                        <TableCell align="center">
                                <img src={row.image ? `${process.env.REACT_APP_API_KEY}images/${row.image}` : "/logo.png"} alt={row.image} width={"100px"} />
                              </TableCell>
                        {
                          lang === "ar" ?
                            <>
                              <TableCell align="center">{row.titleArabic}</TableCell>
                              <TableCell align="center">{row.descriptionArabic}</TableCell>
                              <TableCell align="center">{t(row.discountType)}</TableCell>
                              <TableCell align="center">{convertDate(row.discountStartDate)}</TableCell>
                              <TableCell align="center">{convertDate(row.discountEndDate) }</TableCell>
                              <TableCell align="center">{row.discountRate}</TableCell>
                              <TableCell align="center">{row.amountBeforeDiscount}</TableCell>                              
                              
                              <TableCell align="center">{row.amountAfterDiscount}</TableCell>
                            </>
                            :
                            <>
                              <TableCell align="center">{row.titleEnglish}</TableCell>
                              <TableCell align="center">{row.descriptionEnglish}</TableCell>
                              <TableCell align="center">{t(row.discountType)}</TableCell>
                              <TableCell align="center">{row.discountStartDate}</TableCell>
                              <TableCell align="center">{row.discountEndDate}</TableCell>
                              <TableCell align="center">{row.discountRate}</TableCell>                              
                              <TableCell align="center">{row.amountBeforeDiscount}</TableCell>
                              <TableCell align="center">{row.amountAfterDiscount}</TableCell>
                            </>
                        }
                        <TableCell align="center">
                          <Button onClick={() => handelEdit(row.id)}>
                            <Edit />
                          </Button>
        
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            color="error"
                            onClick={() => handleDelete(row.id)}
                          >
                            <Delete />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={categories.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <Loading />
      )}
    </Box>
  );
}
